<script>
export default {
  test1: 'Log',
  curUser: {
    userName: '',
    userPwd: '',
    openId: '',
    keyInfo: '',
    deptId: 0,
    CorpName: '北京金辉锦江物业服务有限公司'
  },
  deptId: 0,
  loginType: '01', // 01 从本系统登录 02 从外部系统登录
  userRealDept: {},
  userName: '', // 当前登录用户
  curStudent: {
  },
  userRightDeptList: [
    {deptId: 1000000, deptNo: '100000', deptName: '银杏软件', parentDeptId: 0, shortName: '银杏软件', deptLevel: 1, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '', sumLevel: ''},
    {deptId: 1000001, deptNo: '100001', deptName: '测试集团', parentDeptId: 1000000, shortName: '测试集团', deptLevel: 2, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '', sumLevel: ''},
    {deptId: 1000002, deptNo: '100002', deptName: '测试幼儿园', parentDeptId: 1000001, shortName: '测试幼儿园', deptLevel: 3, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '00', sumLevel: ''},
    {deptId: 1000003, deptNo: '100003', deptName: '测试班级', parentDeptId: 1000002, shortName: '测试班级', deptLevel: 4, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '001', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '00|01', sumLevel: ''},
    {deptId: 1000004, deptNo: '100004', deptName: '测试班级1', parentDeptId: 1000002, shortName: '测试班级1', deptLevel: 4, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '002', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '00|02', sumLevel: ''}
  ],
  payUrl: '',
  staticResourceAddr: 'http://www.zft365.com/uploadimages/images/',
  staticUploadAddr: 'http://static.ginkgosoft.cn',
  appTitle: '宅付通', // 标题 -- 宅付通；海棠通
  theme: 'theme-default',
  logOutUrl: 'http://www.zft365.com/',
  tableHeight: 380,
  editInline: false,
  commonParam: {
    curSystem: '01', // 01 通用 02 宅付通
    homePage: './components/Pay/MyBill',
    bannerLogo: './assets/theme-default/images/zftlogo'
  },
  // 分页对象
  page: {
    size: 50,
    totalElements: 0,
    totalPages: 0,
    pageSizes: [15, 50, 100, 500],
    number: 0
  },
  // 用户个性化
  userCustom: {
    isTab: false
  },
  uiSetItemList: [],
  uiSetList: [],
  modeList: [],
  typeIdList: 'Access_URL_Payment,App_Param,Status_Code_Fee_Info,Pay_Type_Ginkgo,CommMode_NewStuPayTime,CommMode_OldStuPayTime,Term_XF,CommMode_OldStuImpPayTime,XF_Coat_Size,XF_Shirt_Size,XF_Shoes_Size',
  uiSetIdList: 'tbIf_Order_Info_MyBillSiYuan,Comm_Single_Table_PayFeeJinHui,tbIf_Order_Info_MyBillShanShiDa,tbIf_Order_Info_Common,tbIf_Order_Info_XiFan,tbIf_Order_Info_XiFan_Exam',
  type: '05',
  // 页面映射表
  pageMap: [
    { type: '01', tabName: 'default', pageName: 'MyBillSiYuan', title: '西安思源学院', pageUrl: 'SiYuan/MyBillSiYuan' },
    { type: '02', tabName: 'default', pageName: 'PayFeeJinHui', title: '金辉物业', pageUrl: 'JinHui/PayFeeJinHui' },
    { type: '05', tabName: 'default', pageName: 'MyBillShanShiDa', title: '陕西师范大学', pageUrl: 'ShanShiDa/MyBillShanShiDa' },
    { type: '10', tabName: 'default', pageName: 'LoginXiFan', title: '西安翻译学院', pageUrl: 'XiFan/LoginXiFan' }
  ]
}
</script>



// WEBPACK FOOTER //
// Global.vue?0632627e